import React from 'react';
import { createBrowserHistory } from 'history';
import { Router } from 'react-router-dom';
import AppRouter from './router';
import { Provider } from 'react-redux';
import { store } from './utils/datasource'
import  loadjs  from 'loadjs';
import { ApolloClient, ApolloProvider, InMemoryCache, HttpLink } from '@apollo/client';
import { ChakraProvider } from "@chakra-ui/react"
const browserHistory = createBrowserHistory();
browserHistory.listen(_ => {
  window.scrollTo(0, 0)  
})

const client = new ApolloClient({
  uri: 'https://childhope.hasura.app/v1/graphql',
  cache: new InMemoryCache()
});
const App = () => {
  return (
    <ChakraProvider>
    <Provider store={store}>
      <ApolloProvider client={client}>
      <Router history={browserHistory} onUpdate={runJQueryScripts}>
        <AppRouter />
      </Router>
      </ApolloProvider>
    </Provider>
    </ChakraProvider>
  );
}

export default App;

const runJQueryScripts = ()=>{
 
}
